import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"

export default function RefundPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Header />

      <main className="mx-auto max-w-4xl px-4 py-10 lg:px-6 lg:py-16">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900">교환/환불 정책</h1>
          <p className="mt-2 text-sm text-slate-500">
            MG퀵플라워 상품의 교환 및 환불에 대한 안내입니다.
          </p>
        </div>

        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
          <div className="space-y-10">

            {/* 교환 안내 섹션 */}
            <section>
              <h2 className="mb-4 text-lg font-bold text-slate-900">교환안내</h2>
              <ul className="list-disc space-y-2 pl-5 text-sm leading-7 text-slate-600 marker:text-slate-400">
                <li>배송된 상품이 파손됐거나 오염되었을 경우</li>
                <li>배송된 상품이 주문한 내용과 다를 경우</li>
                <li>쇼핑몰이 제공한 정보와 다를 경우</li>
              </ul>
            </section>

            {/* 환불 안내 섹션 */}
            <section>
              <h2 className="mb-4 text-lg font-bold text-slate-900">환불안내</h2>
              <ul className="list-disc space-y-2 pl-5 text-sm leading-7 text-slate-600 marker:text-slate-400">
                <li>배송시간 3시간 전에 주문이 취소되었을 경우</li>
                <li>상품이 품절 되었거나 기타 사유로 인해 배송이 불가능한 경우 (환불처리는 12시간 이내에 전액 환불해 드리며, 일체비용은 고객님께서 책임지지 않습니다.)</li>
              </ul>
            </section>

            {/* 교환/환불 불가 섹션 */}
            <section>
              <h2 className="mb-4 text-lg font-bold text-slate-900">교환/환불이 불가능한 경우</h2>
              <ul className="list-disc space-y-2 pl-5 text-sm leading-7 text-slate-600 marker:text-slate-400">
                <li>상품 소재와 관련해서는 교환 및 환불이 불가능합니다.</li>
                <li>수령자의 부재 또는 수령 거부, 잘못된 주소 등 주문서 오작성으로 인해 배송이 잘못된 경우</li>
                <li>배송완료 후 6시간이 지난 상품 (꽃과 화분은 살아있는 생물이라는 특성상 배송완료 후 6시간 이후에는 교환 및 환불이 불가능한 점 양해 부탁드립니다.)</li>
                <li>이용자의 귀책사유로 상품이 훼손된 경우</li>
                <li>상품제작 완료 후 고객님의 변심에 의한 교환 및 환불은 불가능합니다.</li>
              </ul>
            </section>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}